import styled from 'styled-components';

/**
 * Styled component for in-list messages
 */
export const Msg = styled.h4`
	text-align: center;
	padding: 8px;
`;
